/* eslint-disable */
export const multiUnicodes = [
  [ 0x0001f466 ], // 👦
  [ 0x0001F9D2 ], // 🧒
  [ 0x0001F9D1 ], // 🧑 
  [ 0x0001f467 ], // 👧 
  [ 0x0001f468 ], // 👨 
  [ 0x0001f469 ], // 👩 
  [ 0x0001f474 ], // 👴 
  [ 0x0001f475 ], // 👵 
  [ 0x0001F9D3 ], // 🧓 
  [ 0x0001f476 ], // 👶 
  [ 0x0001f471 ], // 👱 
  [ 0x0001F9D4 ], // 🧔 
  [ 0x0001f46e ], // 👮 
  [ 0x0001f472 ], // 👲 
  [ 0x0001f473 ], // 👳 
  [ 0x0001F9D5 ], // 🧕 
  [ 0x0001f477 ], // 👷 
  [ 0x0001f478 ], // 👸 
  [ 0x0001f482 ], // 💂 
  [ 0x0001f385 ], // 🎅 
  [ 0x0001F9D9 ], // 🧙 
  [ 0x0001F9DD ], // 🧝 
  [ 0x0001F9DB ], // 🧛 
  [ 0x0001F9DC ], // 🧜 
  [ 0x0001F9DA ], // 🧚 
  [ 0x0001f47c ], // 👼 
  [ 0x0001f486 ], // 💆 
  [ 0x0001F9D6 ], // 🧖 
  [ 0x0001f487 ], // 💇 
  [ 0x0001f470 ], // 👰 
  [ 0x0001f64d ], // 🙍 
  [ 0x0001f64e ], // 🙎 
  [ 0x0001F937 ], // 🤷 
  [ 0x0001F926 ], // 🤦 
  [ 0x0001f645 ], // 🙅 
  [ 0x0001f646 ], // 🙆 
  [ 0x0001f481 ], // 💁 
  [ 0x0001f64b ], // 🙋 
  [ 0x0001f647 ], // 🙇 
  [ 0x0001f64c ], // 🙌 
  [ 0x0001f64f ], // 🙏 
  [ 0x0001F9B6 ], // 🦶 
  [ 0x0001F9B5 ], // 🦵 
  [ 0x0001f6b6 ], // 🚶 
  [ 0x0001f3c3 ], // 🏃 
  [ 0x0001f483 ], // 💃 
  [ 0x0001f3ca ], // 🏊 
  [ 0x000026f9, 0x0000fe0f ], // ⛹️ 
  [ 0x0001f6b4 ], // 🚴 
  [ 0x0001f6b5 ], // 🚵 
  [ 0x0001f3c4 ], // 🏄 
  [ 0x0001f6c0 ], // 🛀 
  [ 0x0001f6a3 ], // 🚣 
  [ 0x0001F9D7 ], // 🧗 
  [ 0x0001f4aa ], // 💪 
  [ 0x0001f90c ], // 🤌
  [ 0x0001f90f ], // 🤏
  [ 0x0001f448 ], // 👈 
  [ 0x0001f449 ], // 👉 
  [ 0x0000261d ], // ☝️ 
  [ 0x0001f446 ], // 👆 
  [ 0x0001f595 ], // 🖕 
  [ 0x0001f447 ], // 👇 
  [ 0x0000270c ], // ✌️ 
  [ 0x0001f596 ], // 🖖 
  [ 0x0001F91F ], // 🤟 
  [ 0x0001f918 ], // 🤘 
  [ 0x0001f590 ], // 🖐 
  [ 0x0000270a ], // ✊️ 
  [ 0x0000270b ], // ✋️ 
  [ 0x0001f44a ], // 👊 
  [ 0x0001f44c ], // 👌 
  [ 0x0001f44d ], // 👍 
  [ 0x0001f44e ], // 👎 
  [ 0x0001f44b ], // 👋 
  [ 0x0001f44f ], // 👏 
  [ 0x0001F932 ], // 🤲 
  [ 0x0001f450 ], // 👐 
  [ 0x0000270d ], // ✍️ 
  [ 0x0001f485 ], // 💅 
  [ 0x0001f442 ], // 👂 
  [ 0x0001f443 ], // 👃 
  [ 0x0001F469, 0x0000200d, 0x0001F9B1 ], // 👩‍🦱 
  [ 0x0001F9D1, 0x0000200d, 0x0001F9B1 ], // 🧑‍🦱 
  [ 0x0001F468, 0x0000200d, 0x0001F9B1 ], // 👨‍🦱 
  [ 0x0001F469, 0x0000200d, 0x0001F9B0 ], // 👩‍🦰 
  [ 0x0001F9D1, 0x0000200d, 0x0001F9B0 ], // 🧑‍🦰 
  [ 0x0001F468, 0x0000200d, 0x0001F9B0 ], // 👨‍🦰 
  [ 0x0001F469, 0x0000200d, 0x0001F9B3 ], // 👩‍🦳 
  [ 0x0001F9D1, 0x0000200d, 0x0001F9B3 ], // 🧑‍🦳
  [ 0x0001F468, 0x0000200d, 0x0001F9B3 ], // 👨‍🦳 
  [ 0x0001F469, 0x0000200d, 0x0001F9B2 ], // 👩‍🦲 
  [ 0x0001F9D1, 0x0000200d, 0x0001F9B2 ], // 🧑‍🦲
  [ 0x0001F468, 0x0000200d, 0x0001F9B2 ], // 👨‍🦲 
  [ 0x0001F9B8, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🦸‍♀️ 
  [ 0x0001F9B8 ], // 🦸
  [ 0x0001F9B8, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🦸‍♂️ 
  [ 0x0001F9B9, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🦹‍♀️ 
  [ 0x0001F9B9 ], // 🦹
  [ 0x0001F9B9, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🦹‍♂️ 
  [ 0x0001f471, 0x0000200d, 0x00002640, 0x0000fe0f ], // 👱‍♀️ 
  [ 0x0001f471, 0x0000200d, 0x00002642, 0x0000fe0f ], // 👱‍♂️
  [ 0x0001f473, 0x0000200d, 0x00002640, 0x0000fe0f ], // 👳‍♀️ 
  [ 0x0001f473, 0x0000200d, 0x00002642, 0x0000fe0f ], // 👳‍♀️ 
  [ 0x0001f46e, 0x0000200d, 0x00002640, 0x0000fe0f ], // 👮‍♀️ 
  [ 0x0001f46e, 0x0000200d, 0x00002642, 0x0000fe0f ], // 👮‍♂️
  [ 0x0001f477, 0x0000200d, 0x00002640, 0x0000fe0f ], // 👷‍♀️ 
  [ 0x0001f477, 0x0000200d, 0x00002642, 0x0000fe0f ], // 👷‍♀️ 
  [ 0x0001f482, 0x0000200d, 0x00002640, 0x0000fe0f ], // 💂‍♀️ 
  [ 0x0001f482, 0x0000200d, 0x00002642, 0x0000fe0f ], // 💂‍♀️ 
  [ 0x0001f575, 0x0000fe0f, 0x0000200d, 0x00002640, 0x0000FE0F ], // 🕵️‍♀️ 
  [ 0x0001f575 ], // 🕵
  [ 0x0001f575, 0x0000fe0f, 0x0000200d, 0x00002642, 0x0000FE0F ], // 🕵️‍♂️ 
  [ 0x0001f647, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🙇‍♀️ 
  [ 0x0001f647, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🙇‍♂️ 
  [ 0x0001F9D9, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧙‍♂️ 
  [ 0x0001F9D9, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧙‍♀️
  [ 0x0001F9DD, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧝‍♀️ 
  [ 0x0001F9DD, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧝‍♂️
  [ 0x0001F9DB, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧛‍♀️
  [ 0x0001F9DB, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧛‍♂️ 
  [ 0x0001F9DA, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧚‍♀️ 
  [ 0x0001F9DA, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧚‍♂️ 
  [ 0x0001F9DC, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧜‍♀️ 
  [ 0x0001F9DC, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧜‍♂️
  [ 0x0001f481, 0x0000200d, 0x00002640, 0x0000fe0f ], // 💁‍♀️
  [ 0x0001f481, 0x0000200d, 0x00002642, 0x0000fe0f ], // 💁‍♂️ 
  [ 0x0001f645, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🙅‍♀️ 
  [ 0x0001f645, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🙅‍♂️ 
  [ 0x0001f646, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🙆‍♀️
  [ 0x0001f646, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🙆‍♂️ 
  [ 0x0001f64b, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🙋‍♀️
  [ 0x0001f64b, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🙋‍♂️ 
  [ 0x0001f64e, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🙎‍♀️
  [ 0x0001f64e, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🙎‍♂️
  [ 0x0001F937, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🤷‍♀️  
  [ 0x0001F937, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🤷‍♂️ 
  [ 0x0001f64d, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🙍‍♀️
  [ 0x0001f64d, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🙍‍♂️ 
  [ 0x0001f487, 0x0000200d, 0x00002640, 0x0000fe0f ], // 💇‍♀️
  [ 0x0001f487, 0x0000200d, 0x00002642, 0x0000fe0f ], // 💇‍♂️ 
  [ 0x0001f486, 0x0000200d, 0x00002640, 0x0000fe0f ], // 💆‍♀️
  [ 0x0001f486, 0x0000200d, 0x00002642, 0x0000fe0f ], // 💆‍♂️ 
  [ 0x0001F9D6, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧖‍♀️ 
  [ 0x0001F9D6, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧖‍♂️
  [ 0x0001F9D1, 0x0000200D, 0x0001F9BC ], // 🧑‍🦼
  [ 0x0001F468, 0x0000200D, 0x0001F9BC ], // 👨‍🦼
  [ 0x0001F469, 0x0000200D, 0x0001F9BC ], // 👩‍🦼
  [ 0x0001F9D1, 0x0000200D, 0x0001F9BD ], // 🧑‍🦽
  [ 0x0001F468, 0x0000200D, 0x0001F9BD ], // 👨‍🦽
  [ 0x0001F469, 0x0000200D, 0x0001F9BD ], // 👩‍🦽
  [ 0x0001f6b6, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🚶‍♀️ 
  [ 0x0001f6b6, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🚶‍♀️ 
  [ 0x0001F9D1, 0x0000200D, 0x0001F9AF ], // 🧑‍🦯
  [ 0x0001F468, 0x0000200D, 0x0001F9AF ], // 👨‍🦯
  [ 0x0001F469, 0x0000200D, 0x0001F9AF ], // 👩‍🦯
  [ 0x0001F9CE, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🧎‍♀️
  [ 0x0001F9CE ], // 🧎
  [ 0x0001F9CE, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🧎‍♂️	
  [ 0x0001f3c3, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🏃‍♀️ 
  [ 0x0001f3c3, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🏃‍♂️
  [ 0x0001F9CD, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🧍‍♀️
  [ 0x0001F9CD ], // 🧍
  [ 0x0001F9CD, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🧍‍♂️
  [ 0x0001f46b ], // 👫 
  [ 0x0001f46d ], // 👭 
  [ 0x0001f46c ], // 👬 
  [ 0x0001f3cb, 0x0000fe0f, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🏋️‍♀️ 
  [ 0x0001f3cb ], // 🏋
  [ 0x0001f3cb, 0x0000fe0f, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🏋️‍♂️ 
  [ 0x000026f9, 0x0000fe0f, 0x0000200d, 0x00002640, 0x0000fe0f ], // ⛹️‍♀️ 
  [ 0x000026f9 ], // ⛹ 
  [ 0x000026f9, 0x0000fe0f, 0x0000200d, 0x00002642, 0x0000fe0f ], // ⛹️ 
  [ 0x0001f3c4, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🏄‍♀️ 
  [ 0x0001f3c4, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🏄‍♂️
  [ 0x0001F93C, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🤼‍♀️ 
  [ 0x0001F93C ], // 🤼
  [ 0x0001F93C, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🤼‍♂️ 
  [ 0x0001F9D8, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧘‍♂️ 
  [ 0x0001f3ca, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🏊‍♀️ 
  [ 0x0001f3ca, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🏊‍♂️
  [ 0x0001f93d, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🤽‍♀️
  [ 0x0001f93d ], // 🤽‍♂️
  [ 0x0001f93d, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🤽‍♂️
  [ 0x0001f6a3, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🚣‍♀️ 
  [ 0x0001f6a3, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🚣‍♂️
  [ 0x0001F9D7, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧗‍♀️
  [ 0x0001F9D7, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧗‍♂️ 
  [ 0x0001f6b4, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🚴‍♀️ 
  [ 0x0001f6b4, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🚴‍♂️
  [ 0x0001f6b5, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🚵‍♀️ 
  [ 0x0001f6b5, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🚵‍♂️
  [ 0x0001f91b ], // 🤛 
  [ 0x0001f91c ], // 🤜 
  [ 0x0001f91e ], // 🤞 
  [ 0x0001f91a ], // 🤚 
  [ 0x0001f919 ], // 🤙 
  [ 0x0001f933 ], // 🤳 
  [ 0x0001f469, 0x0000200D, 0x00002695, 0x0000fe0f ], // 👩‍⚕️ 
  [ 0x0001f9D1, 0x0000200D, 0x00002695, 0x0000fe0f ], // 🧑‍⚕️ 
  [ 0x0001f468, 0x0000200D, 0x00002695, 0x0000fe0f ], // 👨‍⚕️ 
  [ 0x0001F469, 0x0000200D, 0x0001F33E ], // 👩‍🌾 
  [ 0x0001F9D1, 0x0000200D, 0x0001F33E ], // 🧑‍🌾
  [ 0x0001F468, 0x0000200D, 0x0001F33E ], // 👨‍🌾 
  [ 0x0001F469, 0x0000200D, 0x0001F373 ], // 👩‍🍳 
  [ 0x0001F9D1, 0x0000200D, 0x0001F373 ], // 🧑‍🍳
  [ 0x0001F468, 0x0000200D, 0x0001F373 ], // 👨‍🍳 
  [ 0x0001F469, 0x0000200D, 0x0001F393 ], // 👩‍🎓 
  [ 0x0001F9D1, 0x0000200D, 0x0001F393 ], // 🧑‍🎓
  [ 0x0001F468, 0x0000200D, 0x0001F393 ], // 👨‍🎓 
  [ 0x0001F469, 0x0000200D, 0x0001F3A4 ], // 👩‍🎤 
  [ 0x0001F9D1, 0x0000200D, 0x0001F3A4 ], // 🧑‍🎤
  [ 0x0001F468, 0x0000200D, 0x0001F3A4 ], // 👨‍🎤 
  [ 0x0001F469, 0x0000200D, 0x0001F3EB ], // 👩‍🏫 
  [ 0x0001F9D1, 0x0000200D, 0x0001F3EB ], // 🧑‍🏫
  [ 0x0001F468, 0x0000200D, 0x0001F3EB ], // 👨‍🏫 
  [ 0x0001F469, 0x0000200D, 0x0001F3ED ], // 👩‍🏭 
  [ 0x0001F9D1, 0x0000200D, 0x0001F3ED ], // 🧑‍🏭
  [ 0x0001F468, 0x0000200D, 0x0001F3ED ], // 👨‍🏭 
  [ 0x0001F469, 0x0000200D, 0x0001F4BB ], // 👩‍💻 
  [ 0x0001F9D1, 0x0000200D, 0x0001F4BB ], // 🧑‍💻
  [ 0x0001F468, 0x0000200D, 0x0001F4BB ], // 👨‍💻 
  [ 0x0001F469, 0x0000200D, 0x0001F4BC ], // 👩‍💼 
  [ 0x0001F9D1, 0x0000200D, 0x0001F4BC ], // 🧑‍💼
  [ 0x0001F468, 0x0000200D, 0x0001F4BC ], // 👨‍💼 
  [ 0x0001F469, 0x0000200D, 0x0001F527 ], // 👩‍🔧 
  [ 0x0001F9D1, 0x0000200D, 0x0001F527 ], // 🧑‍🏭
  [ 0x0001F468, 0x0000200D, 0x0001F527 ], // 👨‍🔧 
  [ 0x0001F469, 0x0000200D, 0x0001F52C ], // 👩‍🔬 
  [ 0x0001F9D1, 0x0000200D, 0x0001F52C ], // 👩‍🔬 
  [ 0x0001F468, 0x0000200D, 0x0001F52C ], // 👨‍🔬 
  [ 0x0001F469, 0x0000200D, 0x0001F3A8 ], // 👩‍🎨 
  [ 0x0001F9D1, 0x0000200D, 0x0001F3A8 ], // 🧑‍🎨
  [ 0x0001F468, 0x0000200D, 0x0001F3A8 ], // 👨‍🎨 
  [ 0x0001F469, 0x0000200D, 0x0001F692 ], // 👩‍🚒 
  [ 0x0001F9D1, 0x0000200D, 0x0001F692 ], // 🧑‍🚒
  [ 0x0001F468, 0x0000200D, 0x0001F692 ], // 👨‍🚒 
  [ 0x0001F469, 0x0000200D, 0x00002708, 0x0000FE0F ], // 👩‍✈️ 
  [ 0x0001F9D1, 0x0000200D, 0x00002708, 0x0000FE0F ], // 🧑‍✈️
  [ 0x0001F468, 0x0000200D, 0x00002708, 0x0000FE0F ], // 👨‍✈️ 
  [ 0x0001F469, 0x0000200D, 0x0001F680 ], // 👩‍🚀 
  [ 0x0001F9D1, 0x0000200D, 0x0001F680 ], // 🧑‍🚀
  [ 0x0001F468, 0x0000200D, 0x0001F680 ], // 👨‍🚀 
  [ 0x0001F469, 0x0000200D, 0x00002696, 0x0000FE0F ], // 👩‍⚖️ 
  [ 0x0001F9D1, 0x0000200D, 0x00002696, 0x0000FE0F ], // 🧑‍⚖️
  [ 0x0001F468, 0x0000200D, 0x00002696, 0x0000FE0F ], // 👨‍⚖️ 
  [ 0x0001F936 ], // 🤶 
  [ 0x0001F9D1, 0x0000200D, 0x0001F384 ], // 🧑‍🎄
  [ 0x0001F934 ], // 🤴
  [ 0x0001F977 ], // 🥷
  [ 0x0001F470, 0x0000200D, 0x00002640, 0x000FE0F] , // 👰‍♀️
  [ 0x0001f470 ], // 👰
  [ 0x0001F470, 0x0000200D, 0x00002642, 0x000FE0F] , // 👰‍♂️
  [ 0x0001F935, 0x0000200D, 0x00002640, 0x000FE0F] , // 🤵‍♀️
  [ 0x0001F935 ], // 🤵
  [ 0x0001F935, 0x0000200D, 0x00002642, 0x000FE0F] , // 🤵‍♂️
  [ 0x0001F930 ], // 🤰 
  [ 0x0001F931 ], // 🤱 
  [ 0x0001F469, 0x0000200D, 0x0001F37C ], // 👩‍🍼
  [ 0x0001F9d1, 0x0000200D, 0x0001F37C ], // 🧑‍🍼
  [ 0x0001F468, 0x0000200D, 0x0001F37C ], // 👨‍🍼
  [ 0x0001F9cf, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧏‍♀️ 
  [ 0x0001F9cf ], // 🧏
  [ 0x0001F9cf, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧏‍♂️
  [ 0x0001F926, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🤦‍♀️ 
  [ 0x0001F926 ], // 🤦 
  [ 0x0001F926, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🤦‍♂️
  [ 0x0001F57A ], // 🕺 
  [ 0x0001F938, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🤸‍♀️ 
  [ 0x0001F938 ], // 🤸 
  [ 0x0001F938, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🤸‍♂️ 
  [ 0x0001f3c2 ], // 🏂 
  [ 0x0001f574 ], // 🕴 
  [ 0x0001f3c7 ], // 🏇 
  [ 0x0001F9D8, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧘‍♀️
  [ 0x0001F9D8 ], // 🧘 
  [ 0x0001F9D8, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧘‍♂️ 
  [ 0x0001f3cc, 0x0000fe0f, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🏌️‍♀️ 
  [ 0x0001f3cc ], // 🏌
  [ 0x0001f3cc, 0x0000fe0f, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🏌️‍♂️
  [ 0x0001F93E, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🤾‍♀️
  [ 0x0001F93E ], // 🤾 
  [ 0x0001F93E, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🤾‍♂️ 
  [ 0x0001F939, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🤹‍♀️ 
  [ 0x0001F939 ], // 🤹 
  [ 0x0001F939, 0x0000200D, 0x00002642, 0x0000FE0F ] // 🤹‍♂️
]
